import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../Model/utility/utility.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';

@Component({
  selector: 'app-remark-history',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, LoaderComponent],
  templateUrl: './remark-history.component.html',
  styleUrl: './remark-history.component.scss'
})
export class RemarkHistoryComponent {
  isDisabled: boolean = false;
  SupportData: any = [];
  @Input() InputData: any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private support: SupportTicketService,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
     public activeModal: NgbActiveModal,
  ) {
    //this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  Close(){
    this.activeModal.close();
  }
  getData() {
    this.SupportData = [];
    const Detail = {
      SelectType: 'History',
      ESS_HelpDeskRequestId: this.InputData.ESS_HelpDeskRequestId,
      HelpDeskUserType: 'Admin'
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.SupportData = Object.values(data.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  
  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'HelpDeskSupport' + '/' + Text;
  }
}
